module.exports = __webpack_public_path__ + "img/green-3-squiggly-open.70e5d0cc.svg";